<template lang="pug">
  .wrap(v-if="user.display_aggregations")
    .aggregation
      .aggregation-content-group
        .aggregation-title
          .name
            i.fa.fa-cubes.fa-fw
            | 集計条件
          span.download-links
            a(v-if="currentIndex != null" @click.prevent="copyAggregationCsv")
              | 集計結果をコピー（エクセル等に貼付）
            template(v-else)
              | 集計結果をコピー（エクセル等に貼付）

        .aggregation-search-condition
          .conditions
            .search-company-name
              .label 企業名
              input.company-name(
                type="text",
                v-model="companyName",
                placeholder="企業名またはブランド名")

            .search-keywords
              .search-keyword
                .label キーワード
                select(v-model="searchTargetKeyword")
                  option(v-for="option in searchKeywordTargets" :value="option.code")
                    | {{ option.name }}
                input.keyword(
                  type="text",
                  v-model="keyword",
                  placeholder="職種名または業種名")

            .search-jobtypes
              .label 職種
              input.button(
                type="button"
                @click="toggleJobtypeModal"
                value="職種を選択")
              .selected-search-jobtypes
                template(v-if="jobtypeCd.length > 0")
                  | 【選択内容】
                template(v-for="option in jobtypeCd")
                  | {{ `■${option.label}、` }}
              .modal(:class="{ active: openJobtypeModal }")
                JobtypeModal(
                  :openJobtypeModal="openJobtypeModal"
                  :selectedJobtypeCd="jobtypeCd"
                  :filteredAp="true"
                  @setJobtypeCodes="setJobtypeCodes"
                  @hide="hideJobtypeModal")

            .search-industries
              .label 業種
              input.button(
                type="button"
                @click="toggleIndustryModal"
                value="業種を選択")
              .selected-search-industries
                template(v-if="industryCd.length > 0")
                  | 【選択内容】
                template(v-for="option in industryCd")
                  | {{ `■${option.label}、` }}
              .modal(:class="{ active: openIndustryModal }")
                IndustryModal(
                  :openIndustryModal="openIndustryModal"
                  :selectedIndustryCd="industryCd"
                  @setIndustryCodes="setIndustryCodes"
                  @hide="hideIndustryModal")

            .search-address
              .label エリア
              select.search-address-target(v-model="searchTargetAddress")
                option(v-for="option in searchAddressTargets" :value="option.code")
                  | {{ option.name }}
              input.button(
                type="button"
                @click="toggleCompanyCityModal"
                value="エリアを選択")
              .selected-search-addresses
                template(v-if="searchPrefecture.length > 0 || searchCity.length > 0")
                  | 【選択内容】
                template(v-for="option in searchPrefecture")
                  | {{ `■${option.label}、` }}
                template(v-for="option in searchCity")
                  | {{ `■${option.label}、` }}
              .modal(:class="{ active: openPrefectureCityModal }")
                PrefectureCityModal(
                  :prefectures="this.$store.state.master.prefectures"
                  :groupingPrefecture="true"
                  :openPrefectureCityModal="openPrefectureCityModal"
                  :selectedCityCd="searchCity"
                  :selectedPrefectureCd="searchPrefecture"
                  @setPrefectureCities="setCityCd"
                  @setPrefectures="setPrefectureCd"
                  @hide="hidePrefectureCityModal")

            .search-budgets
              .label 出稿金額
              input(type="text", v-model="budgetLower")
              span.mr-12 万円〜
              input(type="text", v-model="budgetUpper")
              span 万円
              span.error-message(v-if="budgetsErrorMessage != null")
                | {{ budgetsErrorMessage }}

            .search-employment-type
              .label 媒体属性
              label.radio
                input(type='radio' v-model="employmentType" value="1")
                span 中途系
              label.radio
                input(type='radio' v-model="employmentType" value="2")
                span アルバイト系

            .search-range-type
              .label 集計期間
              label.radio
                input(type='radio' v-model="rangeType" value="1")
                span 週次
              label.radio
                input(type='radio' v-model="rangeType" value="2")
                span 月次

          .action
            .aggregation-button
              input.button-main(
                type="button"
                @click="search"
                value="データを集計する"
                :disabled="budgetsErrorMessage != null")
            input.button(
              type="button"
              @click="reset"
              value="集計条件をクリアする")
            .action-description 集計には数分時間がかかります。当月の月次集計は翌月３日を過ぎてから閲覧できるようになります。

      .aggregation-content-group.display-conditions
        .aggregation-title2
          | 集計結果の表示内容

        div
          span.title 基本情報
          label.checkbox
            input.checkbox(type="checkbox", v-model="displayData", :value="1")
            span 求人数
          label.checkbox
            input.checkbox(type="checkbox", v-model="displayData", :value="2")
            span 出稿企業数
          label.checkbox
            input.checkbox(type="checkbox", v-model="displayData", :value="3")
            span 出稿金額
          label.checkbox
            input.checkbox(type="checkbox", v-model="displayData", :value="4")
            span 給与
          span.mr-12 （
          label.radio
            input(type='radio' v-model="displayDataSalary" value="1")
            span 時給
          label.radio
            input(type='radio' v-model="displayDataSalary" value="2")
            span 日給
          label.radio
            input(type='radio' v-model="displayDataSalary" value="3")
            span 月給
          label.radio
            input(type='radio' v-model="displayDataSalary" value="4")
            span 年収
          span ）

        div
          span.title 媒体属性
          label.checkbox
            input(type="checkbox", v-model="displayColumn", :value="1")
            span 媒体名表示
          label.checkbox
            input(type="checkbox", v-model="displayColumn", :value="2")
            span 広告プラン表示

        div
          span.title 表示期間
          template(v-if="this.searchedRangeType == '1'")
            label.radio(v-for="period in this.periods[1]")
              input(type="radio", v-model="displayWeek", :value="period.value")
              span {{ period.label }}
          template(v-else)
            label.checkbox(v-for="period in this.periods[2]")
              input(type="checkbox", v-model="displayMonth", :value="period.value")
              span {{ period.label }}

      .aggregation-content-group.display-results
        .search-results
          .no-data(v-if="emptyIndexData")
            | 集計対象のデータが確認できませんでした。条件を見直して再集計を行ってください。
          .no-data(v-if="timeoutIndexData")
            | 集計対象データが大きいため、集計を完了することができませんでした。条件を見直して再集計を行ってください。
          table(v-if="currentIndex != null")
            colgroup
              col(style="width: 150px")
              template(v-for="m in sortedDisplayPeriods")
                col(style="width: 70px" v-show="displayDataIndexOf(1)")
                col(style="width: 70px" v-show="displayDataIndexOf(2)")
                col(style="width: 70px" v-show="displayDataIndexOf(3)")
                col(style="width: 70px" v-show="displayDataIndexOf(4)")
                col(style="width: 70px" v-show="displayDataIndexOf(4)")
                col(style="width: 70px" v-show="displayDataIndexOf(4)")
            tbody
              tr
                th.row-header.border-hidden
                template(v-if="displayData.length > 0" v-for="m in sortedDisplayPeriods")
                  th.aggregation-table-th(:colspan="displayDataLength")
                    | {{ m }}
              tr
                th.row-header.border-hidden
                template(v-for="m in sortedDisplayPeriods")
                  th.aggregation-table-header(v-show="displayDataIndexOf(1)") 求人数
                  th.aggregation-table-header(v-show="displayDataIndexOf(2)") 出稿企業数
                  th.aggregation-table-header(v-show="displayDataIndexOf(3)") 出稿金額
                  th.aggregation-table-header(v-show="displayDataIndexOf(4)") 下限平均
                  th.aggregation-table-header(v-show="displayDataIndexOf(4)") 平均
                  th.aggregation-table-header(v-show="displayDataIndexOf(4)") 上限平均
              tr
                td.row-header.aggregation-total 合計
                template(v-for="periodData in displayPeriodData(currentIndex.results)")
                  template(v-for="k in 6")
                    td.aggregation-total.text-right(v-show="displayDataIndexOf(k)")
                      | {{ formatDisplayData(periodData, k) }}
              template(v-for="(mediaData, mediaName) in currentIndex.medias")
                tr(v-show="displayColumn.indexOf(1) >= 0")
                  td.row-header.aggregation-media-total
                    | {{ mediaName }}
                  template(v-for="periodData in displayPeriodData(mediaData.results)")
                    template(v-for="k in 6")
                      td.aggregation-media-total.text-right(v-show="displayDataIndexOf(k)")
                        | {{ formatDisplayData(periodData, k) }}
                template(v-for="(plan, planName) in mediaData.plans")
                  tr(v-show="displayColumn.indexOf(2) >= 0")
                    td.aggregation-media
                      | {{ planName }}
                    template(v-for="periodData in displayPeriodData(plan.results)")
                      template(v-for="k in 6")
                        td.text-right(v-show="displayDataIndexOf(k)")
                          | {{ formatDisplayData(periodData, k) }}
      .aggregation-stanby-modal(v-if="isLoading")
        i.fa.fa-spinner.fa-spin.fa-4x
        | 現在集計中です。
        br
        | 集計が完了するまで数分時間がかかります。
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import {
    searchAddressTargets,
    searchKeywordTargets,
    HumanErrorMessages,
    HumanInfoMessages,
  } from '../constants'
  import mapGetSet from '../libs/map-get-set'
  import IndustryModal from './parts/IndustryModal'
  import JobtypeModal from './parts/JobtypeModal'
  import PrefectureCityModal from './parts/PrefectureCityModal'
  import searchAggregation from '../store/modules/searchAggregation'

  export default {
    components: { IndustryModal, JobtypeModal, PrefectureCityModal },
    beforeCreate () {
      this.searchAddressTargets = searchAddressTargets
      this.searchKeywordTargets = searchKeywordTargets

      // 表示期間 月次は直近6ヶ月
      const monthlyPeriods = []
      const now = new Date()
      const finishMonth = new Date(now.getFullYear(), now.getMonth(), 1)
      const currentMonth = new Date(now.getFullYear(), now.getMonth() - 5, 1)
      for (; currentMonth <= finishMonth; currentMonth.setMonth(currentMonth.getMonth() + 1)) {
        monthlyPeriods.push({
          label: `${currentMonth.getFullYear()}年${(currentMonth.getMonth() + 1)}月`,
          value: `${currentMonth.getFullYear()}${`0${currentMonth.getMonth() + 1}`.slice(-2)}`,
        })
      }
      this.periods = {
        // 週次
        1: [
          { label: '直近4W', value: '4' },
          { label: '直近8W', value: '8' },
          { label: '直近12W', value: '12' },
        ],
        // 月次
        2: monthlyPeriods,
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'searchAggregation/apiQuery',
        isLoading: 'aggregation/isLoading',
      }),
      ...mapState({
        user: state => state.user.detail,
        index: state => state.aggregation.index,
        prefectures: state => state.master.prefectures,
        cities: state => state.master.cities,
      }),
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchAggregation.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchAggregation/${k}`, v),
        keys: Object.keys(searchAggregation.state.query),
      }),
      displayDataLength () {
        return this.displayData.filter(d => d < 4).length + (this.displayData.includes(4) ? 3 : 0)
      },
      sortedDisplayPeriods () {
        const query = this.$store.state.searchAggregation.query
        if (this.searchedRangeType === '1') {
          const today = new Date()
          const firstday = new Date(today.getFullYear(), 0, 1)
          const fulldays = Math.floor((today.getTime() - firstday.getTime()) / (1000 * 86400))
          const currentWeek = Math.floor(((fulldays - today.getDay()) + 12) / 7)
          const queryDisplayWeek = parseInt(query.displayWeek, 10)
          const totalWeek = this.currentIndex.results.length
          const displayWeek = totalWeek >= queryDisplayWeek ? queryDisplayWeek : totalWeek

          // 昨年も含む表示の場合
          if (currentWeek < queryDisplayWeek) {
            return new Array(displayWeek).fill(null).map((_, i) => {
              const week = (i + currentWeek + 1) - displayWeek
              if (week < 1) {
                const lastYearFirstday = new Date(today.getFullYear() - 1, 0, 1)
                const lastYearLastday = new Date(today.getFullYear() - 1, 11, 31)
                const lastYearFulldays = Math.floor(
                  (lastYearLastday.getTime() - lastYearFirstday.getTime()) / (1000 * 86400),
                )
                const lastYearWeek = Math.floor(
                  ((lastYearFulldays - lastYearLastday.getDay()) + 12) / 7,
                )
                return `${lastYearLastday.getFullYear()}年${lastYearWeek + week}W`
              }
              return `${today.getFullYear()}年${week}W`
            })
          }
          // 本年だけの表示の場合
          return new Array(displayWeek).fill(null).map((_, i) =>
            `${today.getFullYear()}年${(i + currentWeek + 1) - displayWeek}W`,
          )
        } else if (this.searchedRangeType === '2') {
          const displayMonth = (query.displayMonth.slice()).sort()
          return displayMonth.map(m => `${m.slice(0, 4)}年${parseInt(m.slice(4, 6), 10)}月`)
        }
      },
      budgetsErrorMessage () {
        const lower = parseInt(this.budgetLower, 10)
        const upper = parseInt(this.budgetUpper, 10)
        if (lower > upper) {
          return '※出稿金額は下限が上限を上回らないように設定してください。'
        }
        return null
      },
    },
    data () {
      return this.initialData()
    },
    mounted () {
      // 集計データ表示権限がない場合は求人検索に飛ばす
      if (!this.user.display_aggregations) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        this.$router.push({ name: 'SearchJob' })
        return
      }

      this.$store.dispatch('aggregation/reset')
      this.$store.dispatch('searchAggregation/reset')

      this.displayMonth = this.periods[2].map(p => p.value)
    },
    watch: {
      budgetLower () {
        this.budgetLower = this.budgetLower.replace(/[^0-9]+/, '')
      },
      budgetUpper () {
        this.budgetUpper = this.budgetUpper.replace(/[^0-9]+/, '')
      },
      displayDataSalary () {
        this.updateCurrentIndex()
      },
      employmentType () {
        // 集計結果が表示されていない場合、媒体属性に応じた月給/時給初期値を設定する
        if (!this.searched) {
          if (this.employmentType === '1') {
            // 中途系を選択した場合、給与→月給が初期値
            this.displayDataSalary = '3'
          } else if (this.employmentType === '2') {
            // アルバイト系を選択した場合、給与→時給が初期値
            this.displayDataSalary = '1'
          }
        }
      },
      index () {
        this.updateCurrentIndex()
      },
    },
    methods: {
      initialData () {
        return {
          currentIndex: null,
          emptyIndexData: false,
          openIndustryModal: false,
          openJobtypeModal: false,
          openPrefectureCityModal: false,
          searched: false,
          searchedRangeType: '1',
          timeoutIndexData: false,
        }
      },
      reset () {
        this.$store.dispatch('aggregation/reset')
        this.$store.dispatch('searchAggregation/reset')

        const data = this.initialData()
        Object.keys(data).forEach((key) => {
          this[key] = data[key]
        })
      },
      copyAggregationCsv () {
        // 集計結果データ作成
        // 1行目: ヘッダ(期間)
        let data = '\t'
        const periods = this.sortedDisplayPeriods
        const periodSpacer = Array(this.displayDataLength + 1).join('\t')
        data += periods.join(periodSpacer)
        data += '\n'
        // 2行目: ヘッダ(表示項目名)
        data += '\t'
        periods.forEach(() => {
          if (this.displayDataIndexOf(1)) {
            data += '求人数\t'
          }
          if (this.displayDataIndexOf(2)) {
            data += '出稿企業数\t'
          }
          if (this.displayDataIndexOf(3)) {
            data += '出稿金額\t'
          }
          if (this.displayDataIndexOf(4)) {
            data += '下限平均\t平均\t上限平均\t'
          }
        })
        data += '\n'
        // 3行目(合計)
        data += '合計\t'
        this.displayPeriodData(this.currentIndex.results).forEach((periodData) => {
          for (let i = 1; i <= 6; i += 1) {
            if (this.displayDataIndexOf(i)) {
              data += this.formatDisplayData(periodData, i)
              data += '\t'
            }
          }
        })
        data += '\n'
        // 4行目以降
        Object.keys(this.currentIndex.medias).forEach((mediaName) => {
          const mediaData = this.currentIndex.medias[mediaName]
          // 媒体名表示
          if (this.displayColumn.indexOf(1) >= 0) {
            data += `${mediaName}\t`
            this.displayPeriodData(mediaData.results).forEach((periodData) => {
              for (let i = 1; i <= 6; i += 1) {
                if (this.displayDataIndexOf(i)) {
                  data += this.formatDisplayData(periodData, i)
                  data += '\t'
                }
              }
            })
            data += '\n'
          }
          // 広告プラン表示
          Object.keys(mediaData.plans).forEach((planName) => {
            if (this.displayColumn.indexOf(2) >= 0) {
              data += `${planName}\t`
              this.displayPeriodData(mediaData.plans[planName].results).forEach((periodData) => {
                for (let i = 1; i <= 6; i += 1) {
                  if (this.displayDataIndexOf(i)) {
                    data += this.formatDisplayData(periodData, i)
                    data += '\t'
                  }
                }
              })
              data += '\n'
            }
          })
        })

        // クリップボードにコピー
        const copyFrom = document.createElement('textarea')
        copyFrom.textContent = data
        const bodyElm = document.getElementsByTagName('body')[0]
        bodyElm.appendChild(copyFrom)
        copyFrom.select()
        if (document.execCommand('copy')) {
          this.$store.dispatch('common/pushToastInfo', {
            info: HumanInfoMessages.SUCCESS_COPY_AGGREGATION_CSV,
          })
        }
        bodyElm.removeChild(copyFrom)
      },
      displayDataIndexOf (index) {
        // 給与だけ3カラム分(index=4〜6)あるので4で丸める
        const targetIndex = index >= 4 ? 4 : index
        return this.displayData.indexOf(targetIndex) >= 0
      },
      displayPeriodData (periodData) {
        if (this.searchedRangeType === '1') {
          // 週次の場合、必要な週分のみ表示する
          if (periodData.length < this.displayWeek) {
            return periodData
          }
          const skipWeeks = periodData.length - parseInt(this.displayWeek, 10)
          return periodData.slice(skipWeeks)
        } else if (this.searchedRangeType === '2') {
          // 月次の場合、画面上のチェック状況に応じて表示する
          if (periodData.length > this.periods[2].length) {
            return []
          }
          return periodData.filter((d, i) => this.displayMonth.includes(this.periods[2][i].value))
        }
        return []
      },
      formatDisplayData (periodData, index) {
        switch (index) {
          case 1: // 求人数
            return periodData[0].toLocaleString()
          case 2: // 出稿企業数
            return periodData[1].toLocaleString()
          case 3: // 出稿金額
            return `${Math.floor(periodData[2] / 10000).toLocaleString()}万円`
          case 4: // 下限給与
            if (this.displayDataSalary === '3' || this.displayDataSalary === '4') {
              return `${Math.floor(periodData[3] / 10000).toLocaleString()}万円`
            }
            return `${Math.round(periodData[3]).toLocaleString()}円`
          case 5: // 平均給与
            if (this.displayDataSalary === '3' || this.displayDataSalary === '4') {
              return `${Math.floor(((periodData[3] + periodData[4]) / 2) / 10000).toLocaleString()}万円`
            }
            return `${Math.floor((periodData[3] + periodData[4]) / 2).toLocaleString()}円`
          case 6: // 上限給与
            if (this.displayDataSalary === '3' || this.displayDataSalary === '4') {
              return `${Math.floor(periodData[4] / 10000).toLocaleString()}万円`
            }
            return `${Math.round(periodData[4]).toLocaleString()}円`
          default:
            return ''
        }
      },
      hideIndustryModal () {
        this.openIndustryModal = false
      },
      hideJobtypeModal () {
        this.openJobtypeModal = false
      },
      hidePrefectureCityModal () {
        this.openPrefectureCityModal = false
      },
      async search () {
        this.searched = true
        this.searchedRangeType = this.rangeType
        await this.$store.dispatch('aggregation/fetchAggregations', { query: this.apiQuery })
      },
      async setCityCd (cityCd) {
        this.openPrefectureCityModal = false
        this.searchCity = cityCd
      },
      async setIndustryCodes (industryCodes) {
        this.openIndustryModal = false
        this.industryCd = industryCodes
      },
      async setJobtypeCodes (jobtypeCodes) {
        this.openJobtypeModal = false
        this.jobtypeCd = jobtypeCodes
      },
      async setPrefectureCd (prefectureCd) {
        this.searchPrefecture = prefectureCd
      },
      toggleCompanyCityModal (e) {
        e.stopPropagation()
        this.openPrefectureCityModal = !this.openPrefectureCityModal
      },
      toggleIndustryModal (e) {
        e.stopPropagation()
        this.openIndustryModal = !this.openIndustryModal
      },
      toggleJobtypeModal (e) {
        e.stopPropagation()
        this.openJobtypeModal = !this.openJobtypeModal
      },
      updateCurrentIndex () {
        const salaryMapping = { 1: 'hourly', 2: 'daily', 3: 'monthly', 4: 'annual' }
        const salaryIndex = salaryMapping[this.displayDataSalary]

        const indexData = this.$store.state.aggregation.index
        this.emptyIndexData = false
        this.timeoutIndexData = false

        if (!this.searched) {
          return
        } else if (indexData === 'timeout') {
          this.currentIndex = null
          this.timeoutIndexData = true
          return
        } else if (!Object.keys(indexData).length) {
          this.currentIndex = null
          this.emptyIndexData = true
          return
        } else if (!indexData[salaryIndex]) {
          this.currentIndex = null
          return
        }

        // 表示期間(月次) 更新
        const totalMonth = indexData[salaryIndex].results.length
        const monthlyPeriods = []
        const now = new Date()
        const lastMonth = new Date(now.getFullYear(), now.getMonth(), 1)
        const month = new Date(now.getFullYear(), now.getMonth() - (totalMonth - 1), 1)
        for (; month <= lastMonth; month.setMonth(month.getMonth() + 1)) {
          monthlyPeriods.push({
            label: `${month.getFullYear()}年${(month.getMonth() + 1)}月`,
            value: `${month.getFullYear()}${`0${month.getMonth() + 1}`.slice(-2)}`,
          })
        }
        this.periods[2] = monthlyPeriods
        this.displayMonth = this.periods[2].map(p => p.value)

        this.currentIndex = indexData[salaryIndex]
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Aggregation.vue